// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceGridSimple.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from "react";
import { Table, Column } from "share/components/controls/DataGrid/Izenda.Table";
import GridLayout from "share/components/controls/Izenda.GridLayout";
import Paginator from "share/components/controls/DataGrid/helpers/Izenda.Paginator";
import GroupPanel from "share/components/controls/Izenda.GroupPanel";
import FiltersDataSource from "modules/ReportDesigner/DataSource/Izenda.FiltersDataSource";
import constants from "logic/data/Izenda.ReportDesignerConstants";
import OverflowText from "share/components/controls/Izenda.OverflowText";
import DataGridSearch from "share/components/controls/DataGrid/Izenda.DataGridSearch";
import { observer } from "mobx-react";
import { action } from "mobx";

const TABLE_DEF = constants.TABLE_DEF.SIMPLE_MODE;
const CRITERIA_LIST_SIMPLE_MODE = constants.BUNDLE.CRITERIA_LIST_SIMPLE_MODE;

@observer
export default class DataSourceGridSimple extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired
  };

  @action("onSortChange")
  onSortChange = (columnKey: string, sortDir: string): void => {
    const { store } = this.props;

    store.dataSourceDetail.pageInfo.setColSortDirs(columnKey, sortDir);
    store.searchDataSource();
  };

  @action("onSearch")
  onSearch = (searchProperty: string, searchText: string): void => {
    const { store } = this.props;
    const { dataSourceDetail } = store;

    store.dataSourceDetail.reset();
    store.dataSourceDetail.pageInfo.setSearchValues(searchProperty, searchText);
    store.searchDataSource();
  };

  @action("onPageSizeChange")
  onPageSizeChange = (pageSize: number): void => {
    const { store } = this.props;
    store.dataSourceDetail.pageInfo.setPageSize(pageSize);
    store.goToPage(1);
  };

  @action("onPageChange")
  onPageChange = (page: number): void => {
    const { store } = this.props;
    store.goToPage(page);
  };

  renderCategory({ category }) {
    return <OverflowText text={category} tooltip={category} />;
  }

  renderDbName({ databaseName }) {
    return <OverflowText text={databaseName} tooltip={databaseName} />;
  }

  renderSchemaName({ schemaName }) {
    return <OverflowText text={schemaName} tooltip={schemaName} />;
  }

  renderDataObject({ dataObject }) {
    return <OverflowText text={dataObject} tooltip={dataObject} />;
  }

  renderDataObjectType({ dataObjectType }) {
    return <OverflowText text={dataObjectType} tooltip={dataObjectType} />;
  }

  render() {
    const { store, fieldStore } = this.props;
    const { dataSourceDetail } = store;
    const {
      dataSourceGrid,
      isLoadingRelationship,
      pageInfo: { searchProperty, colSortDirs, totalRecords, pageSize, pageIndex }
    } = dataSourceDetail;

    return (
      <GridLayout className="data-source-grid">
        <GroupPanel className="izenda-FilterDatasource u_noMarginAll">
          <FiltersDataSource store={store} fieldStore={fieldStore} viewMode />
        </GroupPanel>
        <GridLayout.Row>
          <GridLayout.Col cols="8">
            <DataGridSearch options={CRITERIA_LIST_SIMPLE_MODE} value={searchProperty} onSearch={this.onSearch} />
          </GridLayout.Col>
        </GridLayout.Row>
        <Table
          dataSource={dataSourceGrid}
          onSortChange={this.onSortChange}
          sortInfo={colSortDirs}
          isLoading={isLoadingRelationship}
        >
          {!store.model.dataTree.noCategory && <Column {...TABLE_DEF["category"]} cell={this.renderCategory} />}
          <Column {...TABLE_DEF["dbName"]} cell={this.renderDbName} />
          <Column {...TABLE_DEF["schemaName"]} cell={this.renderSchemaName} />
          <Column {...TABLE_DEF["dataObject"]} cell={this.renderDataObject} />
          <Column {...TABLE_DEF["dataObjectType"]} cell={this.renderDataObjectType} />
        </Table>
        <Paginator
          onChange={this.onPageChange}
          onDropdownChange={this.onPageSizeChange}
          totalRecords={totalRecords}
          pageSize={pageSize}
          pageIndex={pageIndex}
        />
      </GridLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSource/Izenda.DataSourceGridSimple.js